import React, { useState, useEffect } from 'react';
import '../urunDiv.css';
import gozleme from '../../assets/menu/yemekler/gozlemeler/gozleme.png';


const Gozlemeler = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const gozlemeKategorileri = {
    'Tüm Gözlemeler': [
      {
        id: 1,
        name: 'Kaşarlı Gözleme',
        price: '₺399,90',
        image: gozleme
      },
      {
        id: 2,
        name: 'Sucuk Kaşarlı Gözleme',
        price: '₺419,90',
        image: gozleme
      },
      {
        id: 3,
        name: 'Kavurma Kaşarlı Gözleme',
        price: '₺449,90',
        image: gozleme
      },
      {
        id: 4,
        name: 'Patates Kaşarlı Gözleme',
        price: '₺374,90',
        image: gozleme
      }
    ],
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Gözlemeler</h2>
        </div>
        
        {Object.entries(gozlemeKategorileri).map(([kategori, gozlemeler]) => (
          <div key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid">
              {gozlemeler.map((gozleme) => (
                <div 
                  key={gozleme.id} 
                  className="urun-kart"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad">{gozleme.name}</h3>
                    <div className="urun-fiyat">{gozleme.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={gozleme.image} alt={gozleme.name} style={{
                      width: '80px',
                      height: '80px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Gözlemeler</h2>
        </div>
        
        {Object.entries(gozlemeKategorileri).map(([kategori, gozlemeler]) => (
          <div style={{marginBottom: '80px'}} key={kategori}>
            <div className="container" style={{marginTop: '20px'}}>
              <h2 style={{marginLeft: 'auto', fontWeight: '700', marginTop: '0px' }}>{kategori}</h2>
            </div>
            <hr style={{color: '#D8D8D8'}} />
            <div className="urun-grid-computer">
              {gozlemeler.map((gozleme) => (
                <div 
                  key={gozleme.id} 
                  className="urun-kart-computer"
                  style={{ cursor: 'pointer' }}
                >
                  <div className="urun-bilgi">
                    <h3 className="urun-ad-computer">{gozleme.name}</h3>
                    <div className="urun-fiyat-computer">{gozleme.price}</div>
                  </div>
                  <div className="urun-resim">
                    <img src={gozleme.image} alt={gozleme.name} style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '100px',
                    }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default Gozlemeler;
